import { memo } from 'react'

import CurrentForm from '@tabeeb/modules/forms/components/CurrentForm'
import SwitchFormDialogContainer from '@tabeeb/modules/forms/containers/SwitchFormDialogContainer'
import InfoMessageDialogContainer from '@tabeeb/modules/forms/containers/InfoMessageDialogContainer'
import ExportFormsToCsvOptionsDialogContainer from '@tabeeb/modules/forms/containers/ExportFormsToCsvOptionsDialogContainer'

import useStyles from './styles'

const Forms = () => {
  const classes = useStyles()
  return (
    <section className={classes.container}>
      <CurrentForm />
      <InfoMessageDialogContainer />
      <SwitchFormDialogContainer />
      <ExportFormsToCsvOptionsDialogContainer />
    </section>
  )
}

export default memo(Forms)
